import {Component, OnDestroy, OnInit} from '@angular/core'
import {ActivatedRoute} from '@angular/router'
import { Subscription } from 'rxjs'
import {ActiveParticipantService} from '../../../services/participants/active-participant.service'
import { ParticipantService } from '../../../services/participants/participant.service'
import {IParticipant} from '@interfaces/interfaces';

@Component({
	selector: 'app-participant-workflow',
	templateUrl: './participant-workflow.component.html',
	styleUrls: ['./participant-workflow.component.scss']
})
export class ParticipantWorkflowComponent implements OnInit, OnDestroy {
	participant: IParticipant

	private subscription = new Subscription();

	constructor(
		private participantService: ParticipantService,
		private activeParticipantService: ActiveParticipantService,
		private route: ActivatedRoute,
	) {
	}

	ngOnInit(): void {
		this.subscription.add(this.activeParticipantService.participant$.subscribe(participant => {
			this.participant = participant;
		}));
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
